import React, { useState, useEffect } from 'react';
import Dropdown from "../dropdowns/dropdown";

interface RealAssetCameraDropdownProps {
    selection: string | null;
    onSelect: (selection: string) => void;
    cameras: string[];
    label?: string;
    className?: string;
}

const RealAssetCameraDropdown: React.FC<RealAssetCameraDropdownProps> = ({
    selection,
    onSelect,
    cameras = [],
    label = "",
    className = "",
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [hasInitialized, setHasInitialized] = useState(false);

    useEffect(() => {
        if (!hasInitialized && cameras.length > 0 && !selection) {
            if (cameras.length === 1) {
                onSelect(cameras[0]);
            } else {
                const hdCamera = cameras.find(camera => camera === "HD");
                if (hdCamera) {
                    onSelect(hdCamera);
                } else {
                    const argusCamera = cameras.find(camera => camera === "ARGUS4K");
                    if (argusCamera) {
                        onSelect(argusCamera);
                    }
                }
            }
            setHasInitialized(true);
        }
    }, [cameras, hasInitialized, onSelect, selection]);

    const filteredCameras = cameras.filter(camera =>
        camera.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <Dropdown
            label={
                selection && selection.length > 8
                    ? selection || label
                    : `Camera: ${selection || label}`
            }
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            className={className}
        >
            <div className="max-h-[14rem] overflow-auto">
                <div className="top-0 bg-white px-4 pt-2 pb-2">
                    <input
                        type="text"
                        className="form-input mt-1 block w-full rounded text-gray-700"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
                {filteredCameras.map((camera) => (
                    <button
                        key={camera}
                        onClick={() => {
                            onSelect(camera);
                            setIsOpen(false);
                        }}
                        className="block w-full px-4 py-2 text-left text-sm hover:bg-blue-300 hover:text-white"
                    >
                        {camera}
                    </button>
                ))}
            </div>
        </Dropdown>
    );
};

export default RealAssetCameraDropdown;